module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-stromerzeugung-12afb7d3f3c90a9dd7bbf8ad5baafb1c.svg";